export const initialState = {
    loadUserApps: {
        data: null,
        isLoading: false,
        error: null,
    },
    pullUserApps: {
        isLoading: false,
        success: null,
        error: null,
    },
    deleteUserApp: {
        deletedAppName: null,
        isLoading: false,
        error: null,
    },
};
const appsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'OLY_LOAD_USER_APPS':
            return {
                ...state,
                loadUserApps: {
                    ...initialState.loadUserApps,
                    isLoading: true,
                },
            };
        case 'OLY_LOAD_USER_APPS_SUCCESS':
            return {
                ...state,
                loadUserApps: {
                    ...initialState.loadUserApps,
                    data: action.payload.loadUserApps,
                },
            };
        case 'OLY_LOAD_USER_APPS_ERROR':
            return {
                ...state,
                loadUserApps: {
                    ...initialState.loadUserApps,
                    error: action.payload.error,
                },
            };
        case 'OLY_PULL_USER_APPS':
            return {
                ...state,
                pullUserApps: {
                    ...initialState.pullUserApps,
                    isLoading: true,
                },
            };
        case 'OLY_PULL_USER_APPS_SUCCESS':
            return {
                ...state,
                pullUserApps: {
                    ...initialState.pullUserApps,
                    success: true,
                },
            };
        case 'OLY_PULL_USER_APPS_ERROR':
            return {
                ...state,
                pullUserApps: {
                    ...initialState.pullUserApps,
                    error: action.payload.error,
                },
            };
        case 'OLY_DELETE_USER_APP':
            return {
                ...state,
                deleteUserApp: {
                    ...initialState.deleteUserApp,
                    isLoading: true,
                },
            };
        case 'OLY_DELETE_USER_APP_SUCCESS':
            return {
                ...state,
                deleteUserApp: {
                    ...initialState.deleteUserApp,
                    deletedAppName: action.payload.deletedAppName,
                },
            };
        case 'OLY_DELETE_USER_APP_ERROR':
            return {
                ...state,
                deleteUserApp: {
                    ...initialState.deleteUserApp,
                    error: action.payload.error,
                },
            };
        case 'OLY_USER_APP_RESET':
            return initialState;
        default:
            return state;
    }
};
export default appsReducer;
